import React, { useState, useEffect } from "react";
import { listAllUnitForMeetingForEmployeeCheck } from "../../redux/actions/meetingRoomAction/meetingRoomAction";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import {
  fetchAttendeesList,
  fetchCurrentAttendeesList,
  updateMeetingDetails,
  updateStep,
  checkAttendeeAvailability,
  setErrorMessage,
  fetchExistingGuest,
} from "../../redux/actions/meetingActions/MeetingAction";
import * as constantMessages from "../../constants/constatntMessages";
import "../Login/style/Login.css";
import LoaderButton from "../Common/LoaderButton";
import {
  checkDuplicateUser,
  getEmployeeListAsPerUnit,
} from "../../redux/actions/userAction/userAction";
import RemoveAttendeesModal from "./RemoveAttendeesModal";
import { useLocation, useNavigate } from "react-router-dom";
import { logOut } from "../../redux/actions/authActions/authAction";
import { toast } from "react-toastify";
import AttendeeDragDrop from "./AttendeeDragDrop";
import ConfirmModal from "./ConfirmModal";
import SmallLoaderButton from "../Common/SmallLoaderButton";

const AddAttendees = (props) => {
  const regularExpression = /^[0-9a-zA-Z .,:;@!#&$()/\-_]+$/;
  const regularNameExpression = /^[0-9a-zA-Z .,:;()/\-_]+$/;
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const dispatch = useDispatch();
  const meetingRoomData = useSelector((state) => state.meetingRoom);
  const meetingData = useSelector((state) => state.meeting);
  const employeeData = useSelector((state) => state.user);
  const authData = useSelector((state) => state.auth);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState(
    "Do you want to save the changes ?"
  );
  const [confirmTitle, setConfirmTitle] = useState("Update Attendees");
  const [addNewSubOption, setAddNewSubOption] = useState(""); // e.g., 'addNewGuest' or 'fromExistingGuest'
  const [addNewPeopleType, setAddNewPeopleType] = useState(""); // new state

  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const location = useLocation();
  const stateData = location.state;
  const [unitId, setUnitId] = useState(null);
  const [selectedAttendeeOption, setSelectedAttendeeOption] = useState([
    { label: "*Name / Email Address", value: "" },
  ]);
  const [selectedEmployeeOption, setSelectedEmployeeOption] = useState([
    { label: "*Name / Emp Id", value: "" },
  ]);
  const [selectedUnitOption, setSelectedUnitOption] = useState([
    { label: "*Select Unit", value: "" },
  ]);

  const [existingGuestOptions, setExistingGuestOptions] = useState([
    { label: "*Name / Email Address", value: "" },
  ]);
  const guestTypeOptions = [
    { value: "new", label: "Add New Guest" },
    { value: "existing", label: "Select from Existing" },
  ];
  const [selectedExistingGuestOption, setSelectedExistingGuestOption] =
    useState(null);

  const [removeAttendeeData, setRemoveAttendeeData] = useState({});
  const [errors, setErrors] = useState({});
  // PRATISHRUTI ADD CODE FOR MEETILG LIST DUPLICATE NOT SHOW
  const [selectedAttendees, setSelectedAttendees] = useState([]);
  const [selectEmployee, setSelectEmployee] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    mode: "physical",
    location: "manual",
    date: "",
    link: "",
    fromTime: "",
    toTime: "",
    roomId: null,
    locationData: "",
    attendyType: "fromPreviousMeeting",
    attendeeId: null,
    name: "",
    email: "",
    unitId: "",
    designation: "",
    companyName: "",
    role: "",
    department: "",
  });
  const [attendeesData, setAttendeesData] = useState([]);

  useEffect(() => {
    if (meetingData?.singleMeetingDetails?.attendees?.length !== 0) {
      setAttendeesData(
        meetingData?.singleMeetingDetails?.attendees?.map(
          ({ rsvp, isAttended, canWriteMOM, empId, ...keepAttrs }) => keepAttrs
        )
      );
    }
  }, [meetingData?.singleMeetingDetails?.attendees]);
  //===========================
  useEffect(() => {
    document.title = "Create Meeting: MinutesVault";
    if (props?.meetingData) {
      if (attendeesData.length === 0) {
        setAttendeesData(
          props?.meetingData?.attendees?.map(
            ({ rsvp, isAttended, canWriteMOM, empId, ...keepAttrs }) =>
              keepAttrs
          )
        );
      }
    }

    if (stateData?.isMeetingDataUpdate || meetingData?.isUpdateStep) {
      document.title = "Update Meeting: MinutesVault";
      if (attendeesData.length === 0) {
        const data = meetingData.singleMeetingDetails?.attendees?.map(
          ({ rsvp, isAttended, canWriteMOM, empId, ...keepAttrs }) => keepAttrs
        );
        setAttendeesData([...attendeesData, ...data]);
      }
    }

    if (employeeData.isDuplicateUser === false) {
      const newAttendee = {
        name: formData.name,
        email: formData.email,
        isEmployee: false,
        designation: formData.designation,
        companyName: formData.companyName,
        role: formData.role,
        department: formData.department,
      };
      if (formData.email !== "" || null) {
        const newAttendeeData = [...attendeesData, newAttendee];

        setAttendeesData(newAttendeeData);
        setFormData({
          ...formData,
          name: "",
          email: "",
          designation: "",
          companyName: "",
          role: "",
          department: "",
        });
      }
    }
    return () => {
      dispatch(setErrorMessage(null));
    };
  }, [meetingData.step, employeeData.isDuplicateUser]);
  useEffect(() => {
    if (
      meetingData?.singleMeetingDetails?.parentMeetingDetails?.length !== 0 &&
      meetingData?.singleMeetingDetails?.parentMeetingId &&
      formData?.attendyType !== "addNewPeople"
    ) {
      setFormData({
        ...formData,
        attendyType: "fromCurrentMeeting",
      });
    }

    if (
      formData.attendyType === "fromPreviousMeeting" &&
      accessToken &&
      (!meetingData?.singleMeetingDetails?.parentMeetingId ||
        (meetingData?.singleMeetingDetails?.parentMeetingId &&
          meetingData?.singleMeetingDetails?.followOnSerialNo > 1))
    ) {
      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);

      dispatch(
        fetchAttendeesList(
          userData.organizationId,
          createdById,
          meetingData?.singleMeetingDetails?.parentMeetingId,
          accessToken
        )
      );
    }

    if (
      accessToken &&
      meetingData?.singleMeetingDetails?.parentMeetingDetails?.length !== 0 &&
      meetingData?.singleMeetingDetails?.parentMeetingId &&
      meetingData?.singleMeetingDetails?.followOnSerialNo === 1
    ) {
      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);

      dispatch(
        fetchCurrentAttendeesList(
          userData.organizationId,
          meetingData?.singleMeetingDetails?.parentMeetingId,
          accessToken
        )
      );
    }
    if (
      accessToken &&
      meetingData?.singleMeetingDetails?.parentMeetingDetails?.length !== 0 &&
      meetingData?.singleMeetingDetails?.parentMeetingId
    ) {
    }
  }, [meetingData?.singleMeetingDetails, addNewPeopleType]);

  const submitAttendeeDetails = async (e) => {
    e.preventDefault();

    if (attendeesData.length === 0) {
      const newErrors = validateForm(formData);
      setErrors(newErrors);
      if (Object.keys(newErrors).length === 0) {
        const errors = {};
        errors.addAttendee = constantMessages.addAttendee;
        setErrors(errors);
      }
    } else {
      if (errors.apiError || errors.duplicateAttendee) {
        setErrors(errors);
        return;
      }
      const meetingId = props?.meetingData?._id
        ? props.meetingData._id
        : meetingData?.singleMeetingDetails?._id;
      const isPropCall = props?.meetingData?._id ? true : false;

      if (attendeesData.length > 1) {
        const payload = {
          isEditMeeting: props?.meetingData ? false : true,
          attendees: attendeesData?.map(
            ({
              rsvp,
              isAttended,
              canWriteMOM,
              empId,
              isActive,
              ...keepAttrs
            }) => keepAttrs
          ),
          organizationId: userData.organizationId,
          sendNotification:
            props?.sendSingleNotification === true ? true : false,
          isUpdate:
            stateData?.isMeetingDataUpdate &&
            meetingData?.singleMeetingDetails.step === 3
              ? true
              : false,
          step: 2,
          meetingStatus:
            meetingData?.singleMeetingDetails?.meetingStatus.status,
          sendSingleNotification:
            props?.sendSingleNotification === true ? true : false,
        };
        const fromUpdate =
          meetingData?.singleMeetingDetails?.step === 3 ? true : false;

        setIsUpdateLoading(true);
        await dispatch(
          updateMeetingDetails(
            meetingId,
            payload,
            accessToken,
            "addAttendee",
            stateData?.isMeetingDataUpdate,
            isPropCall,
            fromUpdate
          )
        );
        setIsUpdateLoading(false);
      } else {
        toast.error("Please add at least 2 attendees.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  const submitAttendeeDetailsByConfirmModal = async () => {
    if (attendeesData.length === 0) {
      const newErrors = validateForm(formData);
      setErrors(newErrors);
      if (Object.keys(newErrors).length === 0) {
        const errors = {};
        errors.addAttendee = constantMessages.addAttendee;
        setErrors(errors);
      }
    } else {
      const meetingId = props?.meetingData?._id
        ? props.meetingData._id
        : meetingData?.singleMeetingDetails?._id;
      const isPropCall = props?.meetingData?._id ? true : false;

      if (attendeesData.length > 1) {
        const payload = {
          isEditMeeting: props?.meetingData ? false : true,
          attendees: attendeesData?.map(
            ({
              rsvp,
              isAttended,
              canWriteMOM,
              empId,
              isActive,
              ...keepAttrs
            }) => keepAttrs
          ),
          organizationId: userData.organizationId,
          sendNotification:
            props?.sendSingleNotification === true ? true : false,
          isUpdate:
            stateData?.isMeetingDataUpdate &&
            meetingData?.singleMeetingDetails.step === 3
              ? true
              : false,
          step: 2,
          meetingStatus:
            meetingData?.singleMeetingDetails?.meetingStatus.status,
          sendSingleNotification:
            props?.sendSingleNotification === true ? true : false,
        };

        setIsUpdateLoading(true);
        await dispatch(
          updateMeetingDetails(
            meetingId,
            payload,
            accessToken,
            "addAttendee",
            stateData?.isMeetingDataUpdate,
            isPropCall,
            false
          )
        );
        setIsUpdateLoading(false);
      } else {
        toast.error("Please add at least 2 attendees.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };
  let createdById;

  if (meetingData?.singleMeetingDetails?.createdById) {
    createdById = meetingData.singleMeetingDetails.createdById;
  } else if (props?.meetingData?.createdById) {
    createdById = props.meetingData.createdById;
  } else {
    createdById = undefined;
  }

  // PRATISHRUTI ADD CODE FOR MEETILG LIST DUPLICATE NOT SHOW
  const addAttendee = async (e) => {
    dispatch(setErrorMessage(null));

    let attendeeList = [];
    if (employeeData.employeeListAsUnit) {
      const newEmpList = employeeData.employeeListAsUnit?.map((item) => ({
        _id: item._id,
        name: item.name,
        email: item.email,
        empId: item.empId,
      }));
      attendeeList = [...attendeeList, ...newEmpList];
    }

    if (meetingData.attendeesList) {
      attendeeList = [...attendeeList, ...meetingData.attendeesList];
    }

    const meetingId = props?.meetingData?._id
      ? props.meetingData._id
      : meetingData?.singleMeetingDetails?._id;

    if (formData.attendyType === "addNewPeople" && addNewPeopleType === "new") {
      const newErrors = validateForm(formData);
      setErrors(newErrors);

      if (Object.keys(newErrors).length === 0) {
        if (attendeesData.length > 0) {
          const attendeeFound = attendeesData.find(
            (u) => u.email === formData.email
          );

          if (attendeeFound) {
            setErrors({
              duplicateAttendee: constantMessages.duplicateAttendee,
            });
            return;
          }
        }

        // Check attendee availability
        setIsLoading(true);
        const errors = await checkAttendeeAvailability(
          { email: formData.email },
          meetingId,
          accessToken
        );

        if (errors.apiError) {
          setIsLoading(false);
          setErrors(errors);
          return;
        }

        const payload = {
          organizationId: userData.organizationId,
          email: formData.email,
        };
        setIsLoading(true);
        await dispatch(checkDuplicateUser(payload, accessToken));
        setIsLoading(false);
        // Create new attendee object
        const newAttendee = {
          label: formData.name,
          value: formData.email,
          email: formData.email,
        };

        //  Add selected attendee to the list
        setSelectedAttendees((prev) => [...prev, newAttendee.value]);

        //  Remove the selected attendee from employeeOptions
        setSelectEmployee((prevOptions) =>
          prevOptions.filter((option) => option.value !== newAttendee.value)
        );

        //  Update selected option in form
        setSelectedAttendeeOption(newAttendee);
      }
    } else if (
      formData.attendyType === "addNewPeople" &&
      addNewPeopleType === "existing"
    ) {
      const label = selectedExistingGuestOption.label;
      const [name, email] = label.split(" / ");
      if (selectedExistingGuestOption?.value) {
        const errors = await checkAttendeeAvailability(
          { email: email },
          meetingId,
          accessToken
        );
        if (errors.apiError) {
          setErrors(errors);
          return;
        }
        const newAttendee = {
          label: name,
          value: email,
          email: email,
        };
        setSelectedAttendees((prev) => [...prev, newAttendee.value]);
        setSelectEmployee((prevOptions) =>
          prevOptions.filter((option) => option.value !== newAttendee.value)
        );
        setSelectedAttendeeOption(newAttendee);
      }
    } else {
      if (formData?.attendeeId) {
        if (attendeesData?.length > 0) {
          const attendeeFound = attendeesData.find(
            (u) => u._id === formData.attendeeId
          );

          if (attendeeFound) {
            setErrors({
              duplicateAttendee: constantMessages.duplicateAttendee,
            });
            return;
          } else {
            const errors = await checkAttendeeAvailability(
              { attendeeId: formData.attendeeId },
              meetingId,
              accessToken
            );
            if (errors.apiError) {
              setErrors(errors);
              return;
            }
          }
        }

        let newAttendee = attendeeList.find(
          (u) => u._id === formData.attendeeId
        );

        if (!newAttendee) {
          setErrors({ invalidAttendee: "Attendee not found in the list" });
          return;
        }

        newAttendee.isEmployee = true;

        const newAttendeeData = [...attendeesData, newAttendee];
        setAttendeesData(newAttendeeData);

        //  Add selected attendee to the list
        setSelectedAttendees((prev) => [...prev, newAttendee._id]);

        //  Remove the selected attendee from employeeOptions
        setSelectEmployee((prevOptions) => {
          const filteredOptions = prevOptions.filter(
            (option) => option.value !== newAttendee._id
          );

          return filteredOptions;
        });

        // Remove other attendees from the same unit
        setSelectedAttendees((prevAttendees) => {
          const filteredAttendees = prevAttendees?.filter(
            (att) =>
              !employeeData?.employeeListAsUnit?.some(
                (emp) =>
                  emp?.unitId === newAttendee?.unitId &&
                  emp?._id !== newAttendee?._id
              )
          );

          return filteredAttendees;
        });

        //  Update selected option in form
        setSelectedAttendeeOption({
          label: newAttendee.name,
          value: newAttendee._id,
          email: newAttendee.email,
        });

        setFormData({
          ...formData,
          email: "",
          attendeeId: null,
        });
      } else {
        const errors = {};

        if (formData.attendyType === "fromEmployeeList" && unitId === null) {
          errors.duplicateAttendee = constantMessages?.unitRequired;
        } else {
          errors.duplicateAttendee = "Please select attendees first.";
        }

        setErrors(errors);
        return errors;
      }
    }
    // if (
    //   formData.attendyType === "addNewPeople" &&
    //   addNewPeopleType === "existing" &&
    //   selectedExistingGuestOption?.value
    // ) {
    //   console.log("selectedExistingGuestOption ->", selectedExistingGuestOption);

    //   const [name, email] = selectedExistingGuestOption.label.split("/");

    //   const newAttendee = {
    //     _id: selectedExistingGuestOption.value,
    //     name: name.trim(),
    //     email: email.trim(),
    //     isEmployee: false,
    //   };

    //   const alreadyExists = attendeesData.find((u) => u._id === newAttendee._id);
    //   if (alreadyExists) {
    //     setErrors({
    //       duplicateAttendee: constantMessages.duplicateAttendee,
    //     });
    //     return;
    //   }

    //   const updatedAttendeeData = [...attendeesData, newAttendee];
    //   setAttendeesData(updatedAttendeeData);

    //   setSelectedAttendees((prev) => [...prev, newAttendee._id]);

    //   setSelectEmployee((prevOptions) =>
    //     prevOptions.filter((emp) => emp.value !== newAttendee._id)
    //   );
    //   setFormData({
    //     ...formData,
    //     email: "",
    //     attendeeId: null,
    //   });
    //   setSelectedExistingGuestOption(null);
    // }
    if (
      formData.attendyType === "addNewPeople" &&
      addNewPeopleType === "existing" &&
      selectedExistingGuestOption?.value
    ) {
      console.log(
        "selectedExistingGuestOption ->",
        selectedExistingGuestOption
      );

      const [name, email] = selectedExistingGuestOption.label.split("/");

      const newAttendee = {
        _id: selectedExistingGuestOption.value,
        name: name.trim(),
        email: email.trim(),
        isEmployee: false,
      };

      const alreadyExists = attendeesData.find(
        (u) => u._id === newAttendee._id
      );
      if (alreadyExists) {
        setErrors({
          duplicateAttendee: constantMessages.duplicateAttendee,
        });
        return;
      }

      const updatedAttendeeData = [...attendeesData, newAttendee];
      setAttendeesData(updatedAttendeeData);

      setSelectedAttendees((prev) => [...prev, newAttendee._id]);

      setExistingGuestOptions((prev) =>
        prev.filter(
          (guest) => guest.value !== selectedExistingGuestOption.value
        )
      );

      setSelectEmployee((prevOptions) =>
        prevOptions.filter((emp) => emp.value !== newAttendee._id)
      );

      setFormData({
        ...formData,
        email: "",
        attendeeId: null,
      });

      setSelectedExistingGuestOption(null);
    }

    setUnitId(null);
    setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
    setSelectedUnitOption([{ label: "*Select Unit", value: "" }]);
    setSelectedAttendeeOption([{ label: "*Name / Email Address", value: "" }]);
    // setExistingGuestOptions([{ label: "*Name / Email Address", value: "" }])
  };

  if (meetingRoomData?.unitList?.length !== 0) {
    var unitOptions = meetingRoomData?.unitList?.map((unit) => {
      const returnData = {
        value: unit._id,
        label: unit.name,
        name: "unitId",
      };
      return returnData;
    });
  }

  const validateForm = (formData) => {
    const errors = {};

    if (formData.attendyType === "addNewPeople") {
      if (!formData.name.trim()) {
        errors.name = constantMessages.nameRequired;
      } else if (!regularNameExpression.test(formData.name)) {
        errors.name = constantMessages.invalidName;
      } else if (formData.name.length < 2 || formData.name.length > 30) {
        errors.name = "Name must be between 2 and 30 characters.";
      }

      if (!formData.email.trim()) {
        errors.email = constantMessages.emailRequired;
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        errors.email = constantMessages.invalidEmail;
      }

      if (formData?.designation?.trim()) {
        if (!regularExpression.test(formData.designation)) {
          errors.designation = constantMessages.invalidDesignation;
        } else if (
          formData.designation.length < 2 ||
          formData.designation.length > 100
        ) {
          errors.designation = constantMessages.characterSizeDesignation;
        }
      }

      if (formData?.companyName?.trim()) {
        if (!regularExpression.test(formData.companyName)) {
          errors.companyName = constantMessages.invalidCompanyName;
        } else if (
          formData.companyName.length < 2 ||
          formData.companyName.length > 50
        ) {
          errors.companyName = "Company name must be between 2-50 characters.";
        }
      }
      if (formData?.role?.trim()) {
        if (!regularExpression.test(formData.role)) {
          errors.role = constantMessages.invalidInput;
        } else if (formData.role.length < 2 || formData.role.length > 100) {
          errors.role = "Role must be between 2-100 characters.";
        }
      }

      if (formData?.department?.trim()) {
        if (!regularExpression.test(formData.department)) {
          errors.department = constantMessages.invalidInput;
        } else if (
          formData.department.length < 2 ||
          formData.department.length > 100
        ) {
          errors.department = "Department must be between 2-100 characters.";
        }
      }
    }

    return errors;
  };

  const handleChange = (e) => {
    setErrors({});
    const { name, value } = e.target;

    const updatedValue = name === "email" ? value.toLowerCase() : value;

    setFormData({
      ...formData,
      [name]: updatedValue,
    });

    if (value === "fromPreviousMeeting" && accessToken) {
      dispatch(
        fetchAttendeesList(
          userData.organizationId,
          createdById,
          meetingData?.singleMeetingDetails?.parentMeetingId,
          accessToken
        )
      );
      setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
      setSelectedUnitOption([{ label: "*Select Unit", value: "" }]);
      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);
      setUnitId(null);
    }
    if (value === "fromCurrentMeeting" && accessToken) {
      setUnitId(null);
      dispatch(
        fetchCurrentAttendeesList(
          userData.organizationId,
          meetingData?.singleMeetingDetails?.parentMeetingId,
          accessToken
        )
      );
      setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
      setSelectedUnitOption([{ label: "*Select Unit", value: "" }]);
      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);
    }

    if (value === "fromEmployeeList") {
      const payload = {
        organizationId: userData.organizationId,
      };
      dispatch(listAllUnitForMeetingForEmployeeCheck(payload, accessToken));
    }
    if (value === "fromEmployeeList") {
      setUnitId(null);
      setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);

      if (employeeData?.userData?.unitDetails) {
        setUnitId(employeeData?.userData?.unitDetails?._id);

        setSelectedUnitOption(e);
        const payload = {
          unitId: employeeData?.userData?.unitDetails?._id,
        };

        dispatch(getEmployeeListAsPerUnit(payload, createdById, accessToken));
        setSelectedUnitOption([
          {
            label: employeeData?.userData?.unitDetails?.name,
            value: employeeData?.userData?.unitDetails?._id,
          },
        ]);
      } else {
        setSelectedUnitOption([{ label: "*Select Unit", value: "" }]);
      }

      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);
    }

    if (value === "addNewPeople" && accessToken) {
      // alert("fromExistingGuest 1")
      // dispatch(
      //   fetchExistingGuest(userData.organizationId, accessToken)
      // );
      // setExistingGuestOptions([
      //   { label: "*Name / Email Address", value: "" },
      // ]);
    }
    if (value === "addNewPeople" && accessToken) {
      setAddNewSubOption(""); //
      // alert("fromExistingGuest 2")
      console.log(existingGuestOptions);
      const getGuests = async () => {
        try {
          const response = await dispatch(
            fetchExistingGuest(userData.organizationId, accessToken)
          );

          const filteredGuestData = response.data
            .filter(
              (guest) => !attendeesData.some((att) => att._id === guest._id)
            )
            .map((guest) => ({
              value: guest._id,
              label: `${guest.name} / ${guest.email}`,
            }));

          setExistingGuestOptions(filteredGuestData);

          setSelectedAttendeeOption([
            { label: "*Name / Email Address", value: "" },
          ]);
        } catch (error) {
          console.error("error fetching guests", error);
        }
      };

      getGuests();

      console.log(attendeesData);
    }
    // if (name === "attendyType" && value === "addNewPeople") {
    //   setAddNewPeopleType("new");
    // }
  };

  useEffect(() => {
    if (
      meetingData?.singleMeetingDetails?.parentMeetingId &&
      meetingData?.singleMeetingDetails?.followOnSerialNo === 1
    ) {
      setFormData({
        ...formData,
        attendyType: "fromCurrentMeeting",
      });
      dispatch(
        fetchCurrentAttendeesList(
          userData.organizationId,
          meetingData?.singleMeetingDetails?.parentMeetingId,
          accessToken
        )
      );
    } else {
      setFormData({
        ...formData,
        attendyType: "fromPreviousMeeting",
      });
    }
  }, []);

  const handleUnitChange = (e) => {
    setErrors({});

    const { name, value } = e;
    setUnitId(value);
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedUnitOption(e);
    const payload = {
      unitId: value,
    };

    dispatch(
      getEmployeeListAsPerUnit(
        payload,
        meetingData?.singleMeetingDetails?.createdById,
        accessToken
      )
    );

    setFormData({
      ...formData,
      roomId: "",
    });
    setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
  };

  const nameFieldValidationCheck = (e) => {
    const errors = {};

    if (!formData?.name?.trim()) {
      errors.name = constantMessages.nameRequired;
    } else if (!regularNameExpression.test(formData.name)) {
      errors.name = constantMessages.invalidName;
    } else if (formData.name.length < 2 || formData.name.length > 30) {
      errors.titleName = "Name must be between 2-30  characters";
    }
    setErrors(errors);
  };

  const emailFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData?.email?.toLowerCase().trim()) {
      errors.email = constantMessages.emailRequired;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = constantMessages.invalidEmail;
    }
    setErrors(errors);
  };

  // PRATISHRUTI ADD CODE FOR MEETILG LIST DUPLICATE NOT SHOW
  // const removeAttendee = (e) => {
  //   const removedAttendee = attendeesData.find(
  //     (item) => item.email === removeAttendeeData.email
  //   );

  //   if (!removedAttendee) {
  //     return;
  //   }

  //   //  Remove attendee from attendeesData
  //   const filteredAttendees = attendeesData.filter(
  //     (item) => item.email !== removeAttendeeData.email
  //   );
  //   setAttendeesData(filteredAttendees);

  //   //  Re-add the removed attendee back to employeeOptions
  //   setSelectedAttendees((prevOptions) => {
  //     const updatedOptions = [
  //       {
  //         value: removedAttendee._id,
  //         label: removedAttendee.name,
  //         name: "attendeeId",
  //       },
  //     ];

  //     return updatedOptions;
  //   });
  //   setSelectEmployee((prevOptions) => {
  //     const updatedOptions = [
  //       {
  //         value: removedAttendee._id,
  //         label: removedAttendee.name,
  //         name: "attendeeId",
  //       },
  //     ];

  //     return updatedOptions;
  //   });

  //   setIsModalOpen(false);

  //   setFormData((prevFormData) => {
  //     const updatedFormData = { ...prevFormData, attendeeId: null };

  //     return updatedFormData;
  //   });
  // };
  const removeAttendee = (e) => {
    const removedAttendee = attendeesData.find(
      (item) => item.email === removeAttendeeData.email
    );

    if (!removedAttendee) {
      return;
    }

    // Remove from attendees
    const filteredAttendees = attendeesData.filter(
      (item) => item.email !== removeAttendeeData.email
    );
    setAttendeesData(filteredAttendees);

    // Optional: If employee, add back to employee dropdown
    setSelectEmployee((prevOptions) => [
      ...prevOptions,
      {
        value: removedAttendee._id,
        label: removedAttendee.name,
        name: "attendeeId",
      },
    ]);

    // ✅ If guest, add back to guest dropdown
    if (!removedAttendee.isEmployee) {
      setExistingGuestOptions((prevOptions) => [
        ...prevOptions,
        {
          value: removedAttendee._id,
          label: `${removedAttendee.name} / ${removedAttendee.email}`,
        },
      ]);
      setErrors({});
    }

    setSelectedAttendees((prev) =>
      prev.filter((id) => id !== removedAttendee._id)
    );

    setIsModalOpen(false);

    setFormData((prevFormData) => ({
      ...prevFormData,
      attendeeId: null,
    }));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  if (meetingData?.attendeesList?.length !== 0) {
    var attendeeOptions = meetingData?.attendeesList?.map((attendee) => {
      const returnData = {
        value: attendee._id,
        label: attendee.name + " / " + attendee.email,
        name: "attendeeId",
      };

      return returnData;
    });
  }
  if (employeeData?.employeeListAsUnit?.length !== 0) {
    var employeeOptions = employeeData?.employeeListAsUnit?.map((attendee) => {
      const returnData = {
        value: attendee._id,
        label: attendee.name + " / " + attendee.empId,
        name: "attendeeId",
      };

      return returnData;
    });
  }
  const handleAttendeeChange = (e) => {
    setErrors({});

    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedAttendeeOption(e);
  };

  const handleGuestChange = (e) => {
    setErrors({});
    setSelectedExistingGuestOption(e);
    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // PRATISHRUTI ADD CODE FOR MEETILG LIST DUPLICATE NOT SHOW
  const existingAttendeeIds = (attendeesData || []).map((att) => att._id);

  console.log("Filtered Available Attendee Options:", attendeeOptions);
  const availableAttendeeOptions = (attendeeOptions || []).filter(
    (option) =>
      !selectedAttendees.includes(option.value) &&
      !existingAttendeeIds.includes(option.value)
  );

  const availableEmployeeOptions = (employeeOptions || []).filter(
    (option) =>
      !selectedAttendees.includes(option.value) &&
      !selectEmployee.includes(option.value) &&
      !existingAttendeeIds.includes(option.value)
  );

  // PRATISHRUTI ADD CODE FOR MEETILG LIST DUPLICATE NOT SHOW
  const handleEmployeeChange = (e) => {
    setErrors({});
    const { name, value } = e;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setSelectedEmployeeOption(e);

    setSelectEmployee((prev) =>
      prev.includes(value) ? prev : [...prev, value]
    );
  };

  const updatedAttendeesData = (attendees) => {
    setAttendeesData(attendees);
  };

  const updateStepWithCheck = () => {
    if (
      meetingData?.singleMeetingDetails?.attendees?.length ===
      attendeesData?.length
    ) {
      if (meetingData?.singleMeetingDetails?.attendees?.length >= 2) {
        dispatch(updateStep(2));
      } else {
        toast.warning("Please add minimum 2 attendees.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } else {
      setIsConfirmModalOpen(true);
    }
  };

  const handleConfirmSubmit = (status) => {
    if (status) {
      if (attendeesData?.length >= 2) {
        submitAttendeeDetailsByConfirmModal();

        setIsConfirmModalOpen(false);
      } else {
        toast.warning("Please add minimum 2 attendees.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } else {
      if (
        meetingData?.singleMeetingDetails?.attendees?.length >= 2 &&
        attendeesData?.length >= 2
      ) {
        dispatch(updateStep(2));
      }

      setIsConfirmModalOpen(false);
    }
  };

  const checkAttendeeCount = () => {
    if (attendeesData.length > 1) {
      dispatch(updateStep(2, true));
      dispatch(setErrorMessage(null));

      setErrors({});
    } else {
      toast.error("Please add at least 2 attendees.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const preventEnterKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <>
      <form className="m-0 p-0 details-form" onSubmit={submitAttendeeDetails}>
        <ConfirmModal
          message={confirmMessage}
          title={confirmTitle}
          buttonName={"Cancel"}
          isCalledFromOthers={true}
          setIsConfirmModalOpen={setIsConfirmModalOpen}
          isConfirmModalOpen={isConfirmModalOpen}
          handleConfirmSubmit={handleConfirmSubmit}
        />
        <RemoveAttendeesModal
          message={constantMessages.deleteAttendeeMessage}
          title={"Remove"}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
          handleSubmit={removeAttendee}
          buttonName={"Remove"}
          attendee={removeAttendeeData}
          allowRemove={props?.meetingData ? false : true}
          meetingData={meetingData?.singleMeetingDetails}
        />
        <div className="inner-detail-form">
          <label className="mb-1 people">Attendee(s)</label>
          {attendeesData?.length > 0 ? (
            <>
              <AttendeeDragDrop
                attendees={attendeesData}
                updatedAttendeesData={updatedAttendeesData}
                setIsModalOpen={setIsModalOpen}
                setRemoveAttendeeData={setRemoveAttendeeData}
                allowRemove={props?.meetingData ? false : true}
              />
            </>
          ) : null}
          <div className="add-people-box show">
            <div className="pb-2">
              <label className="mb-1">Select People</label>
              <div className="w-100">
                {meetingData?.singleMeetingDetails?.parentMeetingId &&
                meetingData?.singleMeetingDetails?.followOnSerialNo === 1 ? (
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="attendyType"
                      value="fromCurrentMeeting"
                      id="flexRadioDefault1"
                      onChange={handleChange}
                      checked={formData.attendyType === "fromCurrentMeeting"}
                    />

                    <label
                      className="mb-2 form-check-label"
                      for="flexRadioDefault1"
                      id="flexRadioDefault1"
                    >
                      Select From Current Meeting
                    </label>
                  </div>
                ) : (
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="attendyType"
                      value="fromPreviousMeeting"
                      id="flexRadioDefault1"
                      onChange={handleChange}
                      checked={formData.attendyType === "fromPreviousMeeting"}
                    />

                    <label
                      className="mb-2 form-check-label"
                      for="flexRadioDefault1"
                      id="flexRadioDefault1"
                    >
                      Select From Previous Meetings
                    </label>
                  </div>
                )}
                <div className="form-check-inline">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="attendyType"
                      value="fromEmployeeList"
                      id="flexRadioDefault2"
                      onChange={handleChange}
                      checked={formData.attendyType === "fromEmployeeList"}
                    />
                    <label
                      className=" mb-2 form-check-label"
                      for="flexRadioDefault2"
                      id="flexRadioDefault2"
                    >
                      Select From Employees (Unit Wise)
                    </label>
                  </div>
                </div>

                <div className="form-check-inline">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="attendyType"
                      value="addNewPeople"
                      id="flexRadioDefault3"
                      checked={formData.attendyType === "addNewPeople"}
                      onChange={handleChange}
                    />
                    <label
                      className=" mb-2 form-check-label"
                      for="flexRadioDefault3"
                      id="flexRadioDefault3"
                    >
                      Add Guest
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {formData.attendyType === "fromPreviousMeeting" ? (
              <Select
                className="fltr-opt"
                placeholder="*Name / Email Address"
                name="attendeeId"
                options={availableAttendeeOptions}
                onChange={handleAttendeeChange}
                value={selectedAttendeeOption}
                defaultValue={selectedAttendeeOption}
              />
            ) : formData.attendyType === "fromEmployeeList" ? (
              <>
                <div className="mb-1">
                  <Select
                    className="fltr-opt"
                    defaultValue={selectedUnitOption}
                    value={selectedUnitOption}
                    name="unitId"
                    options={unitOptions}
                    onChange={handleUnitChange}
                  />
                </div>
                {unitId ? (
                  <Select
                    className="fltr-opt"
                    placeholder="*Name / Employee ID"
                    name="attendeeId"
                    options={availableEmployeeOptions}
                    value={selectedEmployeeOption}
                    onChange={handleEmployeeChange}
                  />
                ) : null}
              </>
            ) : formData.attendyType === "fromCurrentMeeting" ? (
              <Select
                className="fltr-opt"
                placeholder="*Name / Email Address"
                name="attendeeId"
                // options={attendeeOptions}
                options={availableAttendeeOptions}
                onChange={handleAttendeeChange}
                value={selectedAttendeeOption}
              />
            ) : formData.attendyType === "addNewPeople" ? (
              <div>
                {/* <label className="">Select Guest Type</label>
                <select
                  name="addNewPeopleType"
                  className="form-control"
                  value={addNewPeopleType}
                  onChange={(e) => setAddNewPeopleType(e.target.value)}
                >
                  <option value="new" defaultChecked={true}>
                    Add New Guest
                  </option>
                  <option value="existing">Select from Existing</option>
                </select> */}
                <label className="">Select Guest Type</label>
                <Select
                  className="fltr-opt mt-1"
                  name="addNewPeopleType"
                  placeholder="Select Guest Type"
                  options={guestTypeOptions}
                  onChange={(selectedOption) =>
                    setAddNewPeopleType(selectedOption.value)
                  }
                  value={guestTypeOptions.find(
                    (opt) => opt.value === addNewPeopleType
                  )}
                />

                {addNewPeopleType === "new" ? (
                  <div>
                    <label className="mt-2">Add New Guest</label>
                    <div className="row">
                      <div className="col-xl-6 col-md-6 mt-2">
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="*Name"
                          name="name"
                          onKeyDown={preventEnterKey}
                          value={formData.name}
                          onChange={handleChange}
                          onBlur={nameFieldValidationCheck}
                        />
                        {errors.name && (
                          <span className="error-message">{errors.name}</span>
                        )}
                      </div>
                      <div className="col-xl-6 col-md-6 mt-2">
                        <input
                          type="text"
                          placeholder="*Email"
                          autoComplete="off"
                          name="email"
                          value={formData.email}
                          onKeyDown={preventEnterKey}
                          onBlur={emailFieldValidationCheck}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <span className="error-message">{errors.email}</span>
                        )}
                      </div>

                      <div className="col-xl-6 col-md-6 mt-2">
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Designation"
                          name="designation"
                          onKeyDown={preventEnterKey}
                          value={formData.designation}
                          onChange={handleChange}
                        />
                        {errors.designation && (
                          <span className="error-message">
                            {errors.designation}
                          </span>
                        )}
                      </div>

                      <div className="col-xl-6 col-md-6 mt-2">
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Company Name"
                          name="companyName"
                          onKeyDown={preventEnterKey}
                          value={formData.companyName}
                          onChange={handleChange}
                        />
                        {errors.companyName && (
                          <span className="error-message">
                            {errors.companyName}
                          </span>
                        )}
                      </div>

                      <div className="col-xl-6 col-md-6 mt-2">
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Role"
                          name="role"
                          onKeyDown={preventEnterKey}
                          value={formData.role}
                          onChange={handleChange}
                        />
                        {errors.role && (
                          <span className="error-message">{errors.role}</span>
                        )}
                      </div>

                      <div className="col-xl-6 col-md-6 mt-2">
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Department"
                          name="department"
                          onKeyDown={preventEnterKey}
                          value={formData.department}
                          onChange={handleChange}
                        />
                        {errors.department && (
                          <span className="error-message">
                            {errors.department}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ) : addNewPeopleType === "existing" ? (
                  <>
                    <div className="mt-3">
                      <label className="mb-1">Select Existing</label>
                      <Select
                        className="fltr-opt"
                        placeholder="*Name / Email Address"
                        name="attendeeId"
                        // defaultValue={existingGuestOptions}
                        options={existingGuestOptions}
                        onChange={handleGuestChange}
                        value={selectedExistingGuestOption}
                      />
                    </div>
                  </>
                ) : null}
              </div>
            ) : null}

            {errors.duplicateAttendee && (
              <span className="error-message">{errors.duplicateAttendee}</span>
            )}
            {errors.addAttendee && (
              <span className="error-message">{errors.addAttendee}</span>
            )}
            {errors.apiError && (
              <div className="error-message">{errors.apiError}</div>
            )}
            <div className="form-group d-flex atd-button">
              {!isLoading ? (
                <button
                  type="button"
                  className="btn add-btn Mom-btn d-flex align-items-center justify-content-center filter-height"
                  onClick={addAttendee}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="#fff"
                    className="bi bi-plus-circle pointer me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                  </svg>
                  <p> Add </p>
                </button>
              ) : (
                <LoaderButton />
              )}

              {!isUpdateLoading && stateData?.isMeetingDataUpdate ? (
                <>
                  <button
                    className="create-meeting-button Mom-btn filter-height"
                    type="submit"
                  >
                    <p>Update</p>
                  </button>
                </>
              ) : isUpdateLoading && stateData?.isMeetingDataUpdate ? (
                <LoaderButton />
              ) : null}

              {/* {!isLoading && stateData?.isMeetingDataUpdate ? (
                <>
                  <button
                    className="create-meeting-button Mom-btn ms-2"
                    type="submit"
                  >
                    <p>Update</p>
                  </button>
                </>
              ) : meetingData?.updateLoading &&
                stateData?.isMeetingDataUpdate ? (
                <LoaderButton />
              ) : null} */}
            </div>
          </div>

          {meetingData?.errorMessage && (
            <div className="attendee-array-error-messages">
              <ul className="error-list error-message">
                {(Array.isArray(meetingData.errorMessage)
                  ? meetingData.errorMessage
                  : [meetingData.errorMessage]
                ).map((error, index) => (
                  <li key={index} className="error-item">
                    {error}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {props.meetingData ? (
            <Modal.Footer>
              {isLoading ? (
                <SmallLoaderButton />
              ) : (
                <button
                  type="submit"
                  className="create-meeting-button Mom-btn "
                >
                  <p>Submit</p>
                </button>
              )}
            </Modal.Footer>
          ) : (
            <div className="button-outer">
              <div className="d-flex people">
                <button
                  className="add-btn Mom-btn"
                  onClick={(e) => dispatch(updateStep(0, true))}
                >
                  <p>Back</p>
                </button>
              </div>

              {stateData.isMeetingDataUpdate ? (
                <button
                  type="button"
                  className="add-btn Mom-btn"
                  onClick={(e) => {
                    updateStepWithCheck();
                    dispatch(setErrorMessage(null));
                  }}
                >
                  <p>Next</p>
                </button>
              ) : !isLoading && !stateData.isMeetingDataUpdate ? (
                <>
                  {meetingData?.singleMeetingDetails?.attendees?.length === 0 ||
                  meetingData?.singleMeetingDetails?.attendees?.length !==
                    attendeesData?.length ? (
                    <button
                      className="create-meeting-button Mom-btn"
                      type="submit"
                    >
                      <p>Save & Proceed</p>
                    </button>
                  ) : (
                    <button
                      className="create-meeting-button Mom-btn"
                      type="button"
                      onClick={(e) => {
                        checkAttendeeCount();
                      }}
                    >
                      <p>Next</p>
                    </button>
                  )}
                </>
              ) : isLoading && !stateData.isMeetingDataUpdate ? (
                <SmallLoaderButton />
              ) : null}
            </div>
          )}
        </div>
      </form>
    </>
  );
};

export default AddAttendees;
